<script setup lang="ts">
withDefaults(
  defineProps<{
    maxWidth?: string;
  }>(),
  {
    maxWidth: "max-w-[1200px]",
  },
);
</script>

<template>
  <div
    class="mx-auto px-6 md:px-12 xl:px-6 transition-all duration-300 xpirience-container"
    :class="maxWidth"
  >
    <slot />
  </div>
</template>

<style scoped>
/* Clear centring logic */
.xpirience-container {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

@media (min-width: 1024px) {
  /* Only apply the shift if the container is inside a .sidebar-shifted zone (Kanzen/Spendzen content) */
  /* This keeps the container box centered, only padding the content inside */
  :global(.sidebar-shifted) .xpirience-container {
    padding-left: 13rem !important; /*Room for the 11rem menu + 2rem gap */
  }
}
</style>
